<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/account"></ion-back-button>
    </ion-buttons>
    <ion-title>My Cases</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content color="lightmimbo">
  <ion-refresher
    slot="fixed"
    (ionRefresh)="handleRefresh($event)"
    color="primary"
  >
    <ion-refresher-content
      pullingText="Pull to refresh"
      refreshingSpinner="circular"
      refreshingText="Refreshing..."
    >
    </ion-refresher-content>
  </ion-refresher>
  <div class="ion-padding ion-text-center" *ngIf="isLoading">
    <ion-spinner color="primary"></ion-spinner>
  </div>
  <div *ngIf="!isLoading">
    <div>
      <div class="ion-padding ion-text-center" *ngIf="cases.length ===0">
        <ion-text color="darkmimbo">You haven't uploaded any cases.</ion-text>
      </div>
      <div *ngIf="cases.length >0">
        <app-case-card
          *ngFor="let casee of cases"
          [cases]="cases"
          [casee]="casee"
        ></app-case-card>
      </div>
    </div>
  </div>
  <ion-fab-button (click)="addNewCase()"
    ><ion-icon name="add-outline" class="add-outline"></ion-icon
  ></ion-fab-button>
  <ion-infinite-scroll
    (ionInfinite)="onIonInfinite($event)"
    *ngIf="!isLoading && HasMoreData"
  >
    <ion-infinite-scroll-content></ion-infinite-scroll-content>
  </ion-infinite-scroll>
  <div style="width: 100%; height: 70px"></div>
</ion-content>
